import { ReactNode } from 'react';

import { ListTableHeader } from './ListTableHeader/ListTableHeader';
import { ListTableRow } from './ListTableRow/ListTableRow';

import { ListTableWrapper, ListWrapper } from './ListTable.styled';

interface ListTableProps<T extends { id: string }> {
    columnsConfig: ColumnDefinitionType<T>[];
    data: T[];
    onRowClick?: (id: string) => void;
    testId: string;
}

export interface ColumnDefinitionType<T> {
    customFormat?: (data: T[keyof T]) => ReactNode;
    flex: number;
    isMain?: boolean;
    key: keyof T;
    label: string;
    maxWidth?: number;
    minWidth?: number;
}

export const ListTable = <T extends { id: string }>({
    columnsConfig,
    data,
    onRowClick,
    testId,
}: ListTableProps<T>) => {
    const columns = columnsConfig;

    return (
        <ListTableWrapper>
            <ListTableHeader columns={columns} />
            <ListWrapper>
                {data.map((row, index) => (
                    <ListTableRow
                        columns={columns}
                        key={row.id}
                        onRowClick={onRowClick}
                        rowData={row}
                        testId={`${testId}-${index}`}
                    />
                ))}
            </ListWrapper>
        </ListTableWrapper>
    );
};
